export default __webpack_public_path__ + "static/media/maternity.b80ab08b.png";